import { render, staticRenderFns } from "./AccountCenter.vue?vue&type=template&id=aec38c92&scoped=true&"
import script from "./AccountCenter.vue?vue&type=script&lang=js&"
export * from "./AccountCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec38c92",
  null
  
)

export default component.exports